import React from "react"
import { useState } from "react"
import styled from "styled-components"
import FormInput from "../components/FormInput"
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile
} from "firebase/auth"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {darkTheme} from '../components/Themes'
import { Link, useNavigate } from "react-router-dom"


const SignupScreen = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [repeatPass, setRepeatPass] = useState("")
  const [loading, setLoading] = useState(false)
  const [registeredUser, setRegisteredUser] = useState(false)
  const [fullName, setFullName] = useState("")
  const [passError, setPassError] = useState('')
  // const placeholderImg = placeholder
  const navigate = useNavigate()
  
  const handlePasswordChange = (e) => {
    const min6digReg = /.{8,}/
    setPassword(e.target.value)
    const passReg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/
    console.log(passReg.test(e.target.value))
    if(passReg.test(password) === false){
        setPassError('Password should be 6 charcter, must contain atleast 1 digit, 1 uppercase letter, one special character')
        return false
    }
    setPassError('')
    return true
  }

  const handleSignup = async (e) => {
    e.preventDefault()
    const authentication = getAuth()
    if (repeatPass === password && passError === "" ) {
      try {
        setLoading(true)
        const resp = await createUserWithEmailAndPassword(
          authentication,
          email,
          password
        )
        sendEmailVerification(authentication.currentUser)
        updateProfile(resp.user, {
          displayName: fullName,
        })
        toast.success("Verification Email Sent")
        setLoading(false)
        setRegisteredUser(true)
     
      } catch (error) {
        setLoading(false)
        console.log(error.code)

        if (error.code === "auth/email-already-in-use") {
          toast.error("Email Already in use")
        } else {
          toast.error(error.code)

        }
      }
    } else {
      toast("Password Doesn't Match")
    }
  }


 

 
 

 
  return (
    <SignupWrap style={{ height: registeredUser ? "120vh" : "80vh" }}>
      <ToastContainer position={"top-center"} autoClose={3000} limit={1} />

    
        <FormContainer onSubmit={handleSignup} >
          <h2>SIgnup</h2>

          <FormInput
            type="text"
            value={fullName}
            handleOnChange={e => setFullName(e.target.value)}
            label={"Full Name"}
            placeholder={"Full Name"}
            isReq={true}
          />
          <FormInput
            type="email"
            value={email}
            handleOnChange={e => setEmail(e.target.value)}
            label={"Email Address"}
            isReq={true}
            placeholder={"Email Address"}
          />
          <FormInput
            isPassword={true}
            value={password}
            handleOnChange={handlePasswordChange}
            label={"Password"}
            isReq={true}
            placeholder={"Password"}
          />
          <span style={{fontSize: '0.8rem', color:"#dc1d13" }}>{passError}</span>
          <FormInput
            isPassword={true}
            value={repeatPass}
            handleOnChange={e => setRepeatPass(e.target.value)}
            label={"Repeat Password"}
            isReq={true}
            placeholder={"Repeat Password"}
          />
          <div>
            <input required type="checkbox" />
            <label style={{userSelect: 'none'}} htmlFor="checkbox">I agree to terms &#38; conditions</label>
          </div>
          <div style={{display: 'flex',margin: '0.5rem 0'}}>
          <GradientBtn>
            {loading ? (
             "Authenticating..."
            ) : (
              "Register Account"
            )} 
          </GradientBtn>

          </div>
          <BtnLink to="/login" style={{ textAlign: "center" }}>
            Already User? Login Now.
          </BtnLink>
        </FormContainer>
    
    </SignupWrap>
  )
}

export default SignupScreen

const SignupWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
`

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25%;
  max-width: 25%;
  height: 85%;
  h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
  }
  h6 {
    text-align: center;
    font-size: 1rem;
    font-weight: normal;
    text-transform: capitalize;
  }

  .profileImg-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    padding: 1rem 0rem;
    .profile_photo {
      border: 5px solid gray;
      width: 90px;
      height: 90px;
    }

    @media (max-width: 768px) {
      /* width: 90px; */
      height: 90px;
    }
  }
  .profileImg-cont img {
    border-radius: 100%;
    width: 100px;
    height: 100px;
  }

  @media (max-width: 768px) {
    width: 80%;
    max-width: 80%;
  }
`
const TextAreaField = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0rem;

  label {
    color: grey;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
    user-select: none;

  }

  #description {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    border-radius: 6px;
    height: 2.5rem;
    padding: 1rem 0.5rem;
    color: rgba(0, 0, 0, 0.6);
    width: 100%;
    max-width: 100%;
    :focus {
      outline: none;
    }
  }
`
const GradientBtn = styled.button`
   border: none;
  background: ${({theme}) => theme.accent};
;
  border-radius: 6px;
  width: 100%;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  height: 2.5rem;
`

const BtnLink = styled(Link)`
  text-decoration: none;
  font-size: 1rem;
  font-weight: normal;
  cursor: pointer;
  color: ${({theme}) => theme.text};
  user-select: none;

`
